import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate, currencyFormat } from 'utilities/common';

export const DetailOrder = ({ data, privilege }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="shipment">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Order
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            {data?.ref_code && (
              <ListHorizontal title="Kode Ref" content={data?.ref_code} />
            )}

            <ListHorizontal
              title="Layanan"
              content={
                data?.service_type
                  ? `${data?.service_type?.service?.name} - ${data?.service_type?.name}`
                  : '-'
              }
            />

            {data?.received_warehouse && (
              <ListHorizontal
                title="Blind Pickup"
                content="Ya"
              />
            )}

            <ListHorizontal title="Dibuat Oleh" content={data?.created_by} />
            <ListHorizontal
              title="Dibuat Tanggal"
              content={formatDate(data?.created_at)}
            />

            {data?.note && (
              <ListHorizontal title="Catatan" content={data?.note} />
            )}
          </>
        )}
      </div>
    </section>
  );
};


export const DetailPayment = ({ data, privilege }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="payment">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Pembayaran
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            <ListHorizontal
              title="Status"
              content={
                <span className={`badge status-${data?.payment_status}-lt ms-auto `}>
                  {data?.payment_status?.replace('_', ' ')}
                </span>
              }
            />
            {privilege && (
              <>
                {(data?.cod && data?.cod?.value > 0) && (
                  <ListHorizontal
                    title="COD"
                    content={`${currencyFormat(data?.cod?.receive)} / ${currencyFormat(data?.cod?.value)}`}
                  />
                )}
                <ListHorizontal
                  title="Total Charges"
                  content={currencyFormat(data?.total_charges, 'IDR')}
                />
                <ListHorizontal
                  title="Total Paid"
                  content={currencyFormat(data?.total_payments, 'IDR')}
                />
                <ListHorizontal
                  title="Total Cost"
                  content={currencyFormat(data?.total_cost, 'IDR')}
                />{' '}
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export const DetailSender = ({ data, truckingCount }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  const count = data?.type === 'ltl'
                  ? `${data?.shipment_count?.delivered} / ${data?.shipment_count?.total}`
                  : truckingCount
                  ? `${truckingCount?.completed} / ${truckingCount?.total}`
                  : null

  return (
    <section id="sender">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Pengirim
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            {data?.customer && (
              <ListHorizontal title="Customer" content={data?.customer?.name} />
            )}
            {data?.shipper && (
              <ListHorizontal title="Shipper" content={data?.shipper?.name} />
            )}

            {count && (
              <ListHorizontal
                title="Proses"
                content={count}
              />
            )}
          </>
        )}
      </div>
    </section>
  );
};
